import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button, 
  Glyphicon, 
  Modal, 
  Tooltip, 
  OverlayTrigger,
  Col
 } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import { invokeApig } from "../../libs/awsLib";
import "./NewCustomer.css";

export class NewCustomer extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      isLoading: null,
      isEdit: props.customerId ? true : false,
      show: false,
      name:'',
      documentId:'',
      status:''
    };
  }

  validateForm() {
    return (
      this.state.name.length > 0 && 
      this.state.documentId.length > 0 &&
      this.state.status.length > 0
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  createCustomer(customer) {
    return invokeApig({
      path: "/customer",
      method: "POST",
      body: customer
    });
  }

  updateCustomer(customer) {
    return invokeApig({
      path: `/customer`,
      method: "PUT",
      body: customer
    });
  }

  //Método que Obtiene los datos del propietario seleccionado por id
  getCustomer() {
    return invokeApig({
      path: `/customer/${this.props.customerId}`
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleEdit = async event =>{
    event.preventDefault();
    try {
      const results = await this.getCustomer();
      this.setState({ ...results });
    } catch (e) {
      alert(e);
    }
    this.setState({ show: true });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      if (this.state.isEdit) {
	    await this.updateCustomer({
          id: this.props.customerId,
	        name: this.state.name,
          documentId: this.state.documentId,
          status: this.state.status
        });
        this.props.onAlertSuccess({ message: "Cliente actualizado exitosamente!" });
      } else {
        await this.createCustomer({
          name: this.state.name,
          documentId: this.state.documentId,
          status: this.state.status
        });
        this.props.onAlertSuccess({ message: "Cliente ingresado exitosamente!", refresh: true });
      }
      this.handleClose();
    } catch (e) {
      this.props.onAlertError({ message: "Error al guardar cliente! Por favor revise los datos e intente nuevamente." });
    }
    this.setState({ isLoading: false });
  }

  renderFormNew(){

    return(
	  <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Nombre{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al nombre de la razón social o persona natural.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl
	          onChange={this.handleChange}
	          value={this.state.name}
	          placeholder="Ingrese solo texto"
	        />
          </Col>
        </FormGroup>
        <FormGroup controlId="documentId">
          <Col componentClass={ControlLabel} sm={3}>
            RUT{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al rut o identificador tributario.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl
              onChange={this.handleChange}
              value={this.state.documentId}
              placeholder="Ingrese solo texto"
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="status">
          <Col componentClass={ControlLabel} sm={3}>
            Estado{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al estado actual del cliente.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl
              onChange={this.handleChange}
              value={this.state.status}
              placeholder="Ingrese solo texto"
            />
    	  </Col>
        </FormGroup>
        
        <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text={this.state.isEdit ? "Modificar" : "Crear" }
              loadingText="Guardando…"
            />
      </Form>
    );
  }

  render() {
    const tooltipEdit = (<Tooltip id="tooltipEdit"><strong>Modificar</strong></Tooltip>)

    return (
      <div>
      	{
          this.state.isEdit ? 
          <OverlayTrigger placement="top" overlay={tooltipEdit}>
  			    <Button onClick={this.handleEdit}>
              <Glyphicon glyph="edit" />
            </Button> 
          </OverlayTrigger>
          
          :
          <Button bsStyle="primary" onClick={this.handleShow}><Glyphicon glyph="user" />Crear Cliente</Button>
      	}
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Datos del cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.renderFormNew()}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
    </div>
    );
  }
}

export default NewCustomer


// WEBPACK FOOTER //
// ./src/containers/customer/NewCustomer.js